import {createContext} from 'react';

import {CurrentUserData} from '../types';

import {UserDataAction} from '../hooks/useUserData';

export const PeerCtx = createContext(null);

export const MediaCtx = createContext(null);

export const PartyCtx = createContext(null);

export const UserCtx = createContext<CurrentUserData | null>(null);

export const LocalCtx = createContext(null);

export const LoadingContext = createContext(false);

export const UserDataState = createContext<CurrentUserData | null>(
  null,
);

export const UserDataDispatch =
  createContext<React.Dispatch<UserDataAction> | null>(null);
